import { defineMessages } from 'react-intl'

export default defineMessages({
  pastNumberOfDays: {
    defaultMessage: 'Past {number} days',
  },
})
